export default __webpack_public_path__ + "static/media/1445.034bf4d4.png";